export default "__VITE_ASSET__CujZexXQ__"